import React, { Component } from "react";
import { Typography, Paper, Tabs as Tabs1, Tab as Tab1 } from "@material-ui/core";
import ReportManager from "./ReportManager";
import { REPORT_CATEGORIES } from "./reportsMeta";

class ReportsHomeLanding extends Component {
  state = {
    active: 0,
  };

  render() {
    const { active } = this.state;
    const current = REPORT_CATEGORIES[active];

    return (
      <div>
        <Typography variant="h6">Information &amp; Reports</Typography>
        <br />

        <Paper square>
          <Tabs1
            value={active}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            onChange={(e, newValue) => this.setState({ active: newValue })}
            aria-label=""
          >
            {REPORT_CATEGORIES.map((el, index) => (
              <Tab1 value={index} key={el.category} label={el.title} />
            ))}
          </Tabs1>
        </Paper>

        <br />

        {/* key forces a fresh ReportManager per category so its internal state resets */}
        <ReportManager
          key={current.category}
          apikey={this.props.apikey}
          lockedCategory={current.category}
          title={current.title}
        />
      </div>
    );
  }
}

export default ReportsHomeLanding;
